import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchTrendsBundle,
  type ModuleFilters,
  type TrendsBundle,
} from '../api/events';

/**
 * Stable query key for the Events → Trends bundle. Exported so sibling
 * code can invalidate the same key without re-deriving it.
 */
export function eventsTrendsKey(filters?: ModuleFilters) {
  return ['events', 'trends', filters ?? {}] as const;
}

/**
 * Fetch the Events → Trends bundle. A single `/v1/contract` round-trip
 * is plucked into `{ trends, campaign_trend, week_labels, districts }`
 * plus the shared envelope (freshness / anomalies / recorded).
 */
export function useEventsTrends(
  filters?: ModuleFilters,
): UseQueryResult<TrendsBundle, Error> {
  return useQuery({
    queryKey: eventsTrendsKey(filters),
    queryFn: ({ signal }) => fetchTrendsBundle(filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
